module.exports = __webpack_public_path__ + "static/media/profile_oz.31150f22.jpg";